import { render, staticRenderFns } from "./PresentationOverlaps.vue?vue&type=template&id=0fb2d89e&"
import script from "./PresentationOverlaps.vue?vue&type=script&lang=js&"
export * from "./PresentationOverlaps.vue?vue&type=script&lang=js&"
import style0 from "./PresentationOverlaps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports